/* eslint-disable no-nested-ternary */
<template>
  <v-container
    class="font-quicksand"
    :class="{ 'pa-0': $vuetify.breakpoint.smAndDown }"
  >
    <v-breadcrumbs
      :items="breadCrumbs"
      divider="/"
      class="pl-2"
    />
    <v-card class="helmi-card">
      <div
        class="helmi-card-title pl-6 pt-6"
      >
        Varainsiirtoveroilmoitus
      </div>
      <v-card-text
        :class="$vuetify.breakpoint.smAndDown ? 'px-2' : 'px-6'"
        class="pb-2 pt-0"
      >
        <p class="mb-6 ml-0">
          Ostaja maksaa varainsiirtoveron alla näkyvillä henkilökohtaisilla viitenumeroilla.
          Voit tulostaa maksutiedot varainsiirtoveron suorittajaa varten.
          <template v-if="taxDetails.osakevaikiinteisto > 0">
            Välittäjän tulee lähettää varainsiirtoveroilmoitus ostajakohtaisesti kun
            varainsiirtovero on maksettu. Ostajat saavat todistuksen sähköpostiinsa, ja se on
            lisäksi tulostettavissa lähettämisen jälkeen alta.
          </template>
        </p>
        <v-progress-linear
          v-if="loading || !currentProperty.kohdenimi"
          class="my-8"
          color="primary"
          height="10"
          buffer-value="0"
          stream
          indeterminate
        />
        <v-alert
          v-if="taxDetails.osakevaikiinteisto > 0
            && (!currentProperty.yhtionimi
            || !currentProperty.ytunnus
            || !currentProperty.osakealku
            || !currentProperty.huoneistonro)"
          dense
          type="warning"
          border="left"
          color="orange darken-2"
          class="mt-4 mb-2"
        >
          Puutteelliset tiedot - ilmoitusta ei voi lähettää!
        </v-alert>
        <v-alert
          v-if="currentProperty.kohdenimi"
          color="blue-grey"
          type="warning"
          prominent
          text
          icon="home"
          class="py-6 pl-6"
          :class="{ 'text-caption' : $vuetify.breakpoint.smAndDown }"
        >
          <v-row align="center">
            <div class="ml-5">
              <template v-if="taxDetails.osakevaikiinteisto > 0">
                <strong>
                  Taloyhtiö:
                </strong> {{ currentProperty.yhtionimi }}
                <span v-if="!currentProperty.yhtionimi" class="red--text">Arvo puuttuu</span><br>
                <strong>
                  Y-tunnus:
                </strong> {{ currentProperty.ytunnus }}
                <span v-if="!currentProperty.ytunnus" class="red--text">Arvo puuttuu</span><br>
                <strong>
                  Paikkakunta:
                </strong> {{ currentProperty.paikkakunta }}
                <span v-if="!currentProperty.paikkakunta" class="red--text">Arvo puuttuu</span><br>
                <strong>
                  Osakkeiden numerot:
                </strong> {{ currentProperty.osakealku
                  ? `${currentProperty.osakealku} - ${currentProperty.osakeloppu}` : '' }}
                <span v-if="!currentProperty.osakealku" class="red--text">Arvo puuttuu</span><br>
                <strong>
                  Osakemäärä:
                </strong> {{ currentProperty.osakealku ? currentProperty.osakemaara : '0' }} kpl<br>
                <strong>
                  Huoneistotunnus:
                </strong> {{ currentProperty.huoneistonro }}
                <span v-if="!currentProperty.huoneistonro" class="red--text">Arvo puuttuu</span><br>
                <strong>
                  Pinta-ala:
                </strong> {{ currentProperty.yhtpintaala | area }}<br>
                <strong>
                  Kohteen tyyppi:
                </strong> {{ assetTypes[taxDetails.assetDetails.asset
                  || defaultAssetType[currentProperty.kohdetyyppi] || 1] }}<br>
                <strong>
                  Luovutuksen tyyppi:
                </strong> {{ transferTypes[taxDetails.assetDetails.transferType || 1] }}<br>
              </template>
              <template v-else>
                <strong>
                  Osoite:
                </strong> {{ currentProperty.kohdenimi }}<br>
                <strong>
                  Postinumero ja kaupunki:
                </strong> {{ currentProperty.postinumero }} {{ currentProperty.paikkakunta }}<br>
                <strong>
                  Kiinteistötunnus:
                </strong> {{ currentProperty.omkkiinteistotunnus }}<br>
              </template>
            </div>
            <v-spacer/>
            <v-btn
              :class="{ 'mt-4' : $vuetify.breakpoint.smAndDown }"
              class="mx-4 font-quicksand"
              text
              :fab="mobile"
              color="primary"
              @click="modifyTaxTransferDialog()"
            >
              <template v-if="!mobile">
                Muokkaa
              </template>
              <v-icon v-if="mobile" dark>
                edit
              </v-icon>
            </v-btn>
          </v-row>
        </v-alert>

        <additional-shares
          v-if="taxDetails.osakevaikiinteisto > 0 && additionalShares.add_share > 0"
          :additional-shares="additionalShares"
          :asset-types="assetTypes"
          :transfer-types="transferTypes"
        />

        <tax-transfer-summary
          :additional-shares="additionalShares"
        />
        <v-alert
          v-if="datesWrong"
          dense
          type="warning"
          border="left"
          color="orange darken-2"
          class="mt-0 mb-4"
        >
          Omistusoikeuden siirtymispäivä ei voi olla ennen kaupantekopäivää!
        </v-alert>

        <v-alert
          v-for="(seller, index) in currentProperty.sellers"
          :key="index"
          :class="{ 'text-caption' : $vuetify.breakpoint.smAndDown }"
          class="py-6 pl-6"
          type="warning"
          prominent
          text
          color="blue-grey"
          icon="person"
        >
          <v-row align="center">
            <div class="ml-5">
              <strong>
                Myyjä {{ index + 1 }}:
              </strong> {{ seller.nimi }}<br>
              <strong>
                Tyyppi:
              </strong>
              <span :class="{ 'red--text' : seller.sotu === '' }">
                {{ businessOrIndividual(seller.sotu) }}<br>
              </span>
              <strong>
                {{ businessOrIndividual(seller.sotu) === 'Yritys' ? 'Y-tunnus' : 'Henkilötunnus' }}:
              </strong> {{ seller.sotu }}<br>
              <strong>
                Omistusosuus:
              </strong> {{ seller.omistusosuus }} / {{ seller.jakaja }}
            </div>
            <v-spacer/>
            <v-btn
              class="ml-4 modify-seller"
              :class="$vuetify.breakpoint.smAndDown ? '' : 'mr-4'"
              text
              :fab="mobile"
              :depressed="!mobile"
              color="primary"
              @click="editSeller(seller)"
            >
              <template v-if="!mobile">
                Muokkaa
              </template>
              <v-icon v-if="mobile" dark>
                edit
              </v-icon>
            </v-btn>
          </v-row>
        </v-alert>

        <v-card
          v-for="(offerer, index) in taxDetails.offerers"
          :key="`offerer-card-${index}`"
          width="100%"
          :color="offerer.taxStatus
            && offerer.taxStatus.UniqueIdentifier ? '#4f9252' : 'primary darken-1'"
          dark
          class="mx-auto my-8 elevation-20"
        >
          <v-card-text :class="mobile ? 'text-caption' : ''" class="white--text">
            <v-row align="center" wrap>
              <v-col
                cols="12"
                md="4"
                class="py-3"
              >
                <v-list-item :class="mobile ? 'px-0' : ''">
                  <v-list-item-icon :class="mobile ? 'mr-3' : 'mr-5'" color="grey">
                    <v-icon
                      :x-large="!mobile"
                      :large="mobile"
                      class="mt-1"
                    >
                      {{ offerer.taxStatus
                        && offerer.taxStatus.UniqueIdentifier ? 'how_to_reg' : 'account_circle' }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="white--text"
                      :class="mobile ? 'text-body-1' : 'title font-weight-regular'"
                    >
                      {{ offerer.nimi }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="white--text">
                      {{ businessOrIndividual(offerer.sotu) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="py-0"
              >
                <b>{{ businessOrIndividual(offerer.sotu) === 'Yritys'
                  ? 'Y-tunnus' : 'Henkilötunnus' }}:</b> {{ offerer.sotu }}<br>
                <b>Varainsiirtovero:</b> {{ offerer.ensiasunnonostaja
                  ? 'Ei varainsiirtoverovelvollinen' : 'Varainsiirtoverovelvollinen' }}<br>
                <b>Sähköposti:</b> {{ offerer.email }}<br>
                <b>Omistusosuus:</b> {{ offerer.osuus }} / {{ offerer.jakaja }}
              </v-col>
              <v-col
                v-if="offerer.taxStatus && offerer.taxStatus.UniqueIdentifier"
                class="py-0"
                cols="12"
                md="4"
              >
                <b>Vastaanottonumero: </b>
                {{ offerer.taxStatus.UniqueIdentifier }}<br>
                <b>Vastaanottoaika: </b>
                {{ formatDateTime(offerer.taxStatus.AcceptedTimestamp) }}<br>
                <b>Maksettu määrä:</b>
                {{ totalForOfferer(offerer) | currency }}<br>
                <b>Maksun viitenumero:</b> {{ offerer.reference ?
                  offerer.reference : 'Yhteys verohallintoon epäonnistui' }}
              </v-col>
              <v-col
                v-else
                cols="12"
                md="4"
              >
                <template
                  v-if="individualSellersExist && isBusiness(offerer.sotu)"
                >
                  <b>Myyjillä yhteyksiä tähän yritykseen:</b>
                  {{ offerer.interestDetail && offerer.interestDetail
                    .some(i => i.InterestCorporateBuyerIndividualSeller === true)
                    ? 'Kyllä' : 'Ei' }}<br>
                </template>
                <template
                  v-else-if="businessSellersExist && isBusiness(offerer.sotu) === false"
                >
                  <b>Yhteyksiä myyjäyhteisöön:</b>
                  {{ offerer.interestDetail && offerer.interestDetail
                    .some(i => i.InterestIndividualBuyerCorporateSeller === true)
                    ? 'Kyllä' : 'Ei' }}<br>
                </template>
                <b>Maksettava määrä:</b>
                {{ totalForOfferer(offerer) | currency }}<br>
                <b>Maksun viitenumero:</b> {{ offerer.reference ?
                  offerer.reference : 'Yhteys verohallintoon epäonnistui' }}
              </v-col>
            </v-row>

            <v-alert
              v-if="offerer.taxStatus && offerer.taxStatus.ErrorText"
              dense
              type="info"
              border="left"
              class="mt-4 mb-2"
            >
              Korjaa seuraavat kohteen tai kaupan tiedoissa olevat virheet ja yritä uudelleen:<br>
              <strong>{{ responseErrors(offerer.taxStatus) }}</strong>
              <strong
                v-if="!(taxDetails.kauppahintailmanlainaosuutta > 0)
                  && !(taxDetails.lainaosuus > 0)"
              >
                <br>Kauppahinnan tai yhtiölainaosuuden pitää olla enemmän kuin 0,00 €
              </strong>
            </v-alert>

            <v-alert
              v-if="offerer.reference === 'Virheellinen henkilötunnus tai y-tunnus'"
              dense
              type="warning"
              border="left"
              color="orange darken-2"
              class="mt-4 mb-2"
            >
              Ostaja: {{ offerer.reference }}
            </v-alert>
            <template v-if="offerer.taxStatus && errorDetails(offerer)">
              <v-alert
                v-for="(error, idx) in errorDetails(offerer)"
                :key="`${index}-error-${idx}-${error.ErrorCode}`"
                dense
                type="warning"
                border="left"
                color="orange darken-2"
                class="mt-4 mb-2"
              >
                {{ errorReferences[error.ErrorReference] || error.ErrorReference }}:
                {{ errorCodes[error.ErrorCode] || error.ErrorDescriptionFI }}
              </v-alert>
            </template>
            <v-alert
              v-if="offerer.jakaja === '0' && offerer.osuus > 0"
              dense
              type="warning"
              border="left"
              color="orange darken-2"
              class="mt-4 mb-2"
            >
              Virheellinen omistusosuus
            </v-alert>

            <v-alert
              v-if="offerer.email === ''"
              dense
              type="warning"
              border="left"
              color="orange darken-2"
              class="mt-4 mb-2"
            >
              Sähköpostiosoite puuttuu!
            </v-alert>
            <v-alert
              v-if="!validateEmail(offerer.email)"
              dense
              type="warning"
              border="left"
              color="orange darken-2"
              class="mt-4 mb-2"
            >
              Sähköpostiosoite virheellinen!
            </v-alert>
          </v-card-text>

          <v-card-actions style="background: rgba(0,0,0,0.06)">
            <v-spacer/>
            <v-btn
              text
              @click="editOfferer(offerer)"
            >
              <template v-if="!mobile">
                Muokkaa
              </template>
              <v-icon v-else>
                edit
              </v-icon>
            </v-btn>
            <v-btn
              text
              @click="print(offerer)"
            >
              <template v-if="!mobile">
                Tulosta
              </template>
              <v-icon v-else>
                print
              </v-icon>
            </v-btn>
            <v-btn
              text
              :disabled="
                offerer.email === ''
                  || datesWrong
                  || !addSharesValid
                  || (offerer.jakaja === '0' && offerer.osuus > 0)
                  || !currentProperty.ytunnus
                  || !currentProperty.yhtionimi
                  || !currentProperty.osakealku
                  || !validateEmail(offerer.email)
                  || offerer.reference === 'Virheellinen henkilötunnus tai y-tunnus'
                  || taxDetails.osakevaikiinteisto < 1"
              @click="sendDialog(offerer)"
            >
              <template v-if="!mobile">
                {{ offerer.taxStatus && offerer.taxStatus.UniqueIdentifier
                  ? 'Lähetetty' : 'Lähetä' }}
              </template>
              <v-icon v-else>
                send
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-alert
          v-if="currentProperty.kohdenimi"
          :class="{ 'text-caption' : $vuetify.breakpoint.smAndDown }"
          text
          color="blue-grey"
          prominent
          class="mt-5"
        >
          <b>VEROHALLINTO</b><br>
          <table style="width: 100%;">
            <tr>
              <td>NORDEA</td>
              <td>{{ banks.nordea }}</td>
            </tr>
            <tr>
              <td>DANSKE BANK</td>
              <td>{{ banks.danske }}</td>
            </tr>
          </table>
        </v-alert>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="440"
    >
      <v-card>
        <v-card-title class="text-h5 mb-0 pb-0" style="word-break: unset;">
          Lähetä varainsiirtoveroilmoitus
          {{ (selectedOfferer.taxStatus
            && !!selectedOfferer.taxStatus.UniqueIdentifier) ? 'uudelleen' : '' }}
        </v-card-title>
        <v-card-text>
          <v-col v-if="selectedOfferer.ensiasunnonostaja" class="px-0 pt-0 pb-6">
            <p>Ostaja: {{ selectedOfferer.nimi }}</p>
            <p class="caption mb-0 font-weight-regular">
              Täyttyvätkö ostajan verovapauden edellytykset?
            </p>
            <v-select
              v-model="firstTimeBuyerValue"
              class="mt-1 mb-2"
              :items="firstTimeBuyerConditions"
              hide-details
              dense
              outlined
            />
          </v-col>

          Lähettämällä varainsiirtoveroilmoituksen Verohallinnolle, vahvistan, että
          varainsiirtovero on maksettu ja kaupanteon kaikki tiedot ovat oikein.<br><br>
          Kun Verohallinto on vastaanottanut varainsiirtoveroilmoituksen onnistuneesti,
          luovutuksensaaja saa todistuksen seuraavaan sähköpostiosoitteeseen:
          <b>{{ selectedOfferer.email }}</b>.
          <v-alert
            v-if="!currentProperty.test || currentProperty.test < 1"
            dense
            type="warning"
            border="left"
            color="orange darken-2"
            class="mt-4 mb-2"
          >
            Estetty testijärjestelmästä!
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Peruuta
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="!currentProperty.test || currentProperty.test < 1"
            :loading="sending"
            @click="sendTaxTransferDetails(selectedOfferer)"
          >
            Lähetä
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taxTransferDialog"
      persistent
      max-width="400"
    >
      <modify-tax-transfer :asset-details="assetDetails"/>
    </v-dialog>
    <v-dialog
      v-model="offererDialog"
      persistent
      max-width="500"
    >
      <edit-offerer :offerer="editedPerson"/>
    </v-dialog>
    <v-dialog
      v-model="sellerDialog"
      persistent
      max-width="500"
    >
      <edit-seller :seller="editedPerson"/>
    </v-dialog>
    <v-dialog
      v-model="successDialog"
      max-width="500"
    >
      <v-card color="primary darken-2" dark>
        <v-card-title :class="mobile ? 'text-body-1' : 'text-h5'">
          <v-icon v-if="mobile" class="mr-1">
            check
          </v-icon>
          Lähetetty onnistuneesti
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              Varainsiirtoveroilmoitus on lähetetty onnistuneesti Verohallinnolle.
              Luovutuksensaaja on saanut todistuksen sähköpostiin, ja voit nyt myös
              ladata ja tulostaa sen PDF-tiedostona.
            </v-col>
            <v-icon
              v-if="!mobile"
              size="128"
              class="mr-2"
            >
              check
            </v-icon>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="white"
            text
            @click="successDialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import _ from 'lodash';

const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('../assets/fonts.js');

export default {
  name: 'TaxTransfer',
  components: {
    'modify-tax-transfer': () => import('@/components/taxTransfer/ModifyTaxTransfer'),
    'tax-transfer-summary': () => import('@/components/taxTransfer/TaxTransferSummary'),
    'additional-shares': () => import('@/components/taxTransfer/AdditionalShares'),
    'edit-offerer': () => import('@/components/EditOfferer'),
    'edit-seller': () => import('@/components/EditSeller'),
  },
  data: () => ({
    additionalShares: {
      add_share: 0,
      add_share2: 0,
      residentialID: '',
      assetType: '1',
      transferType: '1',
      shareSellingPrice: 0,
      buyerShareLoan: 0,
      area: 0,
      firstTimeBuyer: false,
    },
    dialog: false,
    successDialog: false,
    banks: {
      nordea: 'FI64 1660 3000 1176 25',
      danske: 'FI56 8919 9710 0007 24',
    },
    loading: false,
    firstTimeBuyerValue: 'Kyllä, ostaja vakuuttaa',
    firstTimeBuyerConditions: ['Kyllä, ostaja vakuuttaa', 'Ei'],
    portionOfSellingPrice: 0,
    offererDialog: false,
    sellerDialog: false,
    taxTransferDialog: false,
    selectedOfferer: {},
    sending: false,
    editedPerson: {},
    errorReferences: {
      CompanyID: 'Taloyhtiö',
      SellerID: 'Myyjä',
      BuyerID: 'Ostaja',
      BuyerDateOfBirth: 'Ostajan henkilötunnus',
      BuyerShareSellingPrice: 'Ostajan osuus kauppahinnasta',
    },
    errorCodes: {
      502: 'Yhteys verohallintoon epäonnistui',
      1101: 'Virheellinen henkilötunnus tai Y-tunnus.',
      1103: 'Virheellinen Y-tunnus',
      1104: 'Virheellinen syntymäaika',
      1110: 'Virheellinen omistusosuus',
      2003: 'Ostajan henkilötunnus tai Y-tunnus on pakollinen',
      2004: 'Kentän voi antaa vain, kun ostaja on henkilöasiakas',
      2005: 'Arvo puuttuu',
      2008: 'Kenttä on annettava kun [Ostajan tunnus] puuttuu ja ostaja on yhteisöasiakas.',
      2030: 'Varainsiirtoveroilmoituksen lähettäminen Verohallinnolle onnistuu vasta kaupantekopäivänä.',
      2052: 'Omistusoikeuden siirtymispäivä on aikaisempi kuin kaupantekopäivä.',
      2089: 'Tarkista Y-tunnus',
      2093: 'Tarkista henkilötunnus',
      2103: 'Virhe myyjien omistusosuuksissa.',
      2046: 'Huoneistotunnus puuttuu',
    },
    defaultAssetType: {
      0: 1,
      1: 1,
      2: 1,
      3: 4,
      4: 1,
      5: 2,
      6: 2,
      7: 2,
      8: 1,
      9: 1,
      10: 4,
      11: 4,
      12: 4,
      13: 1,
      14: 1,
      15: 1,
      16: 2,
      17: 1,
      18: 1,
      19: 2,
      20: 2,
      21: 1,
      22: 1,
    },
    transferTypes: {
      1: 'Kauppa',
      2: 'Vaihto',
      3: 'Muu',
    },
    assetDetails: {},
  }),
  computed: {
    ...mapState({
      currentProperty: state => state.currentProperty,
      taxDetails: state => state.taxDetails,
    }),
    assetTypes() {
      return {
        1: `Osakehuoneisto ${this.taxDetails.varainsiirtoveroprosentti}%`,
        2: `Parkkipaikka/varasto/liiketila ${this.taxDetails.varainsiirtoveroprosentti}%`,
        3: 'Yrityksen osake 1,6%',
        4: `Lomaosake ${this.taxDetails.varainsiirtoveroprosentti}%`,
        5: 'Osuus puhelinyhtiöstä 1,6%',
        6: 'Muu arvopaperi 1,6%',
      };
    },
    errorDetails() {
      return (offerer) => {
        const skippedKeys = ['BuyerIndividualForeignID', 'BuyerCorporateForeignID', 'BuyerShareOtherCompensation', 'BuyerShareLoan', 'BuyerShareSellerHouseLoan'];

        return offerer.taxStatus
          .ErrorDetails?.filter(error => !skippedKeys.includes(error.ErrorReference));
      };
    },
    responseErrors() {
      const messages = {
        'Expected at least one Object in Array.  Path: $.AssetDetails[0].SellerDetails': 'Kohteelta puuttuu myyjät, tai myyjän omistusosuus on virheellinen',
        'Expected: Number, found: Null.  Path: $.AssetDetails[0].AmountTransferTax': 'Veron määrää ei voitu laskea. Tarkista ostajan omistusosuus',
      };
      return taxStatus => messages[taxStatus?.ErrorText];
    },
    addSharesValid() {
      if (this.taxDetails.additionalShares.add_share > 0) {
        return this.additionalShares.residentialID !== '' && (this.additionalShares.buyerShareLoan > 0 || this.additionalShares.shareSellingPrice > 0);
      }
      return true;
    },
    datesWrong() {
      return (moment(this.taxDetails.kaupantekopaiva, 'DD.MM.YYYY') > moment(this.taxDetails.omistusoikeuspaiva, 'DD.MM.YYYY'));
    },
    addShareCount() {
      if (!this.taxDetails.additionalShares) return 0;
      if (this.taxDetails.additionalShares.add_share2 > 0
        && this.taxDetails.additionalShares.add_share > 0) {
        return parseInt(this.taxDetails.additionalShares.add_share2, 10)
          - parseInt(this.taxDetails.additionalShares.add_share, 10);
      }
      return 0;
    },
    transferSent() {
      if (this.taxDetails.offerers) {
        return this.taxDetails.offerers
          .some(offerer => offerer.taxStatus && offerer.taxStatus.UniqueIdentifier);
      }
      return false;
    },
    propertyId() {
      return this.$route.params.propertyId || null;
    },
    individualSellersExist() {
      return this.currentProperty
        .sellers.some(s => this.isBusiness(s.sotu) === false);
    },
    businessSellersExist() {
      return this.currentProperty
        .sellers.some(s => this.isBusiness(s.sotu));
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    addSharesSellingPrice() {
      if (!this.taxDetails.additionalShares) return 0;

      return (parseFloat(this.taxDetails.additionalShares.shareSellingPrice)
        - parseFloat(this.taxDetails.additionalShares.buyerShareLoan)) * 1;
    },
    taxTotals() {
      let addshareTax = 0;
      let regular = (+this.taxDetails.kauppahinnanvero) * 100
        + ((+this.taxDetails.yhtiolainanvero) * 100 || 0);
      regular /= 100;

      if (this.taxDetails && this.taxDetails.additionalShares.add_share > 0) {
        addshareTax = (+this.taxDetails.addShareLoanTax) * 100
          + (+this.taxDetails.addShareTax) * 100;
        addshareTax /= 100;
      }
      return {
        regular,
        addshareTax,
      };
    },
    breadCrumbs() {
      if (!this.currentProperty.kohdenimi) return [];
      return [
        {
          disabled: false,
          href: this.currentProperty.propertypath,
          link: true,
          text: this.currentProperty.kohdenimi,
        }, {
          disabled: false,
          link: false,
          text: 'Varainsiirtoveroilmoitus',
        }];
    },
  },
  async created() {
    this.$bus.$on('closeTaxTransferDialog', () => {
      this.taxTransferDialog = false;
    });

    this.$bus.$on('closeOffererDialog', () => {
      this.offererDialog = false;
    });

    this.$bus.$on('closeSellerDialog', () => {
      this.sellerDialog = false;
    });

    this.$bus.$on('reload', async () => {
      this.loading = true;
      await this.setCurrentProperty(this.propertyId);
      if (this.taxDetails.additionalShares.add_share) {
        this.additionalShares = _.cloneDeep(this.taxDetails.additionalShares);
      }
      this.loading = false;
    });

    await this.setCurrentProperty(this.propertyId);
    this.assetDetails = _.cloneDeep(this.taxDetails.assetDetails);
    if (this.taxDetails.additionalShares.add_share) {
      this.additionalShares = _.cloneDeep(this.taxDetails.additionalShares);
    }
    this.additionalShares.add_share = this.currentProperty.add_share;
    this.additionalShares.add_share2 = this.currentProperty.add_share2;
  },
  methods: {
    ...mapActions({
      setCurrentProperty: 'setCurrentProperty',
      sendTaxTransfer: 'sendTaxTransfer',
    }),
    currency(value) {
      return this.$options.filters.currency(value || 0);
    },
    area(value) {
      return this.$options.filters.area(value);
    },
    isBusiness(value) {
      if (value.length === 9) return true;
      return false;
    },
    formatDateTime(time) {
      return moment(time).format('DD.MM.YYYY H:m:s:SSS');
    },
    modifyTaxTransferDialog() {
      this.taxTransferDialog = true;
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    totalForOfferer(offerer) {
      return this.totalRegularForOfferer(offerer) + this.totalAdditionalForOfferer(offerer);
    },
    totalRegularForOfferer(offerer) {
      if (!offerer.ensiasunnonostaja && offerer.jakaja > 0) {
        return (this.taxTotals.regular / this.taxDetails.verovelvollistenosuus)
          * (offerer.osuus / offerer.jakaja);
      }

      if (offerer.ensiasunnonostaja && offerer.jakaja > 0) {
        return ((this.taxDetails.firstTimeBuyerTax / (1 - this.taxDetails.verovelvollistenosuus)
          * offerer.osuus / offerer.jakaja));
      }

      return 0;
    },
    totalAdditionalForOfferer(offerer) {
      if (!offerer.ensiasunnonostaja && offerer.jakaja > 0) {
        return this.taxTotals.addshareTax * (offerer.osuus / offerer.jakaja);
      }

      if (offerer.ensiasunnonostaja
        && offerer.jakaja > 0
        && this.taxDetails.additionalShares
        && !this.taxDetails.additionalShares.firstTimeBuyer) {
        return this.taxTotals.addshareTax * (offerer.osuus / offerer.jakaja);
      }

      if (offerer.ensiasunnonostaja
        && offerer.jakaja > 0
        && this.taxDetails.additionalShares
        && this.taxDetails.additionalShares.firstTimeBuyer) {
        return 0;
      }

      return 0;
    },
    additionalSharesPdf() {
      if (!this.taxDetails.additionalShares.add_share > 0) return [];
      return [
        [
          {
            text: ' ',
            colSpan: 2,
          },
          '',
        ],
        [
          {
            text: '2. osakeryhmä:',
            bold: true,
          },
          {
            text: `${this.taxDetails.additionalShares.add_share}-${this.taxDetails.additionalShares.add_share2}`,
          },
        ],
        [
          {
            text: 'Huoneistotunnus:',
          },
          {
            text: this.taxDetails.additionalShares.residentialID,
          },
        ],
        [
          {
            text: 'Pinta-ala:',
          },
          {
            text: `${this.taxDetails.additionalShares.area} m²`,
          },
        ],
        [
          {
            text: 'Kohteen tyyppi:',
          },
          {
            text: this.assetTypes[this.taxDetails.additionalShares.assetType || 1],
          },
        ],
        [
          {
            text: 'Luovutuksen tyyppi:',
          },
          {
            text: this.transferTypes[this.taxDetails.additionalShares.transferType || 1],
          },
        ],
        [
          {
            text: 'Kauppahinta:',
          },
          {
            text: this.currency(this.addSharesSellingPrice),
          },
        ],
        [
          {
            text: 'Yhtiölainaosuus:',
          },
          {
            text: this.currency(this.taxDetails.additionalShares.buyerShareLoan),
          },
        ],
        [
          {
            text: 'Velaton kauppahinta:',
          },
          {
            text: this.currency(this.taxDetails.additionalShares.shareSellingPrice),
          },
        ],
        [
          {
            text: 'Kauppahinnan vero:',
          },
          {
            text: this.currency(this.taxDetails.addSummaryTax),
          },
        ],
        [
          {
            text: 'Yhtiölainan vero:',
          },
          {
            text: this.currency(this.taxDetails.addSummaryLoanTax),
          },
        ],
      ];
    },
    additionalSharesFromCertificatePdf(offerer) {
      if (!offerer.taxStatus.certificate || !offerer.taxStatus.certificate.addShareGroup) return [];
      return [
        [
          {
            text: ' ',
            colSpan: 2,
          },
          '',
        ],
        [
          {
            text: '2. osakeryhmä:',
            bold: true,
          },
          {
            text: offerer.taxStatus.certificate.addShareGroup.shareNumbers,
          },
        ],
        [
          {
            text: 'Huoneistotunnus:',
          },
          {
            text: offerer.taxStatus.certificate.addShareGroup.residentialID,
          },
        ],
        [
          {
            text: 'Pinta-ala:',
          },
          {
            text: `${offerer.taxStatus.certificate.addShareGroup.area} m²`,
          },
        ],
        [
          {
            text: 'Kohteen tyyppi:',
          },
          {
            text: this.assetTypes[offerer.taxStatus.certificate.addShareGroup.assetType || 1],
          },
        ],
        [
          {
            text: 'Luovutuksen tyyppi:',
          },
          {
            text: this.transferTypes[offerer.taxStatus.certificate.addShareGroup.transferType || 1],
          },
        ],
        [
          {
            text: 'Kauppahinta:',
          },
          {
            text: this.currency(offerer.taxStatus.certificate.addShareGroup.sellingPrice),
          },
        ],
        [
          {
            text: 'Yhtiölainaosuus:',
          },
          {
            text: this.currency(offerer.taxStatus.certificate.addShareGroup.shareLoan),
          },
        ],
        [
          {
            text: 'Velaton kauppahinta:',
          },
          {
            text: this.currency(offerer
              .taxStatus.certificate.addShareGroup.unencumberedSellingPrice),
          },
        ],
        [
          {
            text: 'Kauppahinnan vero:',
          },
          {
            text: this.currency(offerer.taxStatus.certificate.addShareGroup.priceTax),
          },
        ],
        [
          {
            text: 'Yhtiölainan vero:',
          },
          {
            text: this.currency(offerer.taxStatus.certificate.addShareGroup.loanTax),
          },
        ],
      ];
    },
    print(offerer) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-MediumItalic.ttf',
        },
        Icons: {
          normal: 'Icons.ttf',
        },
      };

      let content = {};
      if (offerer.taxStatus && offerer.taxStatus.UniqueIdentifier) {
        content = {
          table: {
            widths: ['*', '*'],
            body: [
              [
                {
                  text: 'TODISTUS SUORITETUSTA VARAINSIIRTOVEROSTA\n',
                  fontSize: 15,
                  color: '#333333',
                  colSpan: 2,
                  margin: [0, 0, 0, 20],
                },
                ' ',
              ],
              [
                {
                  text: 'Taloyhtiö:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.CompanyName : this.currentProperty.yhtionimi,
                },
              ],
              [
                {
                  text: 'Y-tunnus:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.CompanyID : this.currentProperty.ytunnus,
                },
              ],
              [
                {
                  text: 'Paikkakunta:',
                },
                {
                  text: this.currentProperty.paikkakunta,
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 0, 0, 5],
                },
                ' ',
              ],
              [
                {
                  text: 'Velaton kokonaiskauppahinta:',
                },
                {
                  text: offerer.taxStatus.certificate.addShareGroup
                    ? this.currency(+offerer.taxStatus.certificate.kauppahinta
                    + +offerer.taxStatus.certificate.addShareGroup.unencumberedSellingPrice)
                    : this.currency(+offerer.taxStatus.certificate.kauppahinta),
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 0, 0, 5],
                },
                ' ',
              ],
              [
                {
                  text: 'Osakkeiden numerot:',
                  bold: true,
                },
                {
                  text: offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.ShareNumbers
                    : `${this.currentProperty.osakealku} - ${this.currentProperty.osakeloppu}`,
                },
              ],
              [
                {
                  text: 'Huoneistotunnus:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.ResidentialID
                    : this.currentProperty.huoneistonro,
                },
              ],
              [
                {
                  text: 'Pinta-ala:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? this.area(offerer.taxStatus.certificate.AreaM2)
                    : this.area(this.currentProperty.yhtpintaala),
                },
              ],
              [
                {
                  text: 'Kohteen tyyppi:',
                },
                {
                  text: this.assetTypes[this.taxDetails.assetDetails.asset || 1],
                },
              ],
              [
                {
                  text: 'Luovutuksen tyyppi:',
                },
                {
                  text: this.transferTypes[this.taxDetails.assetDetails.transferType || 1],
                },
              ],
              [
                {
                  text: 'Kaupantekopäivä:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.kaupantekopaiva
                    : this.taxDetails.kaupantekopaiva,
                },
              ],
              [
                {
                  text: 'Kauppahinta:',
                },
                {
                  text: `${(offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.kauppahintailmanlainaosuutta
                    : this.taxDetails.kauppahintailmanlainaosuutta).toFixed(2).replace('.', ',')} €`,
                },
              ],
              [
                {
                  text: 'Yhtiölainaosuus:',
                },
                {
                  text: `${(offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.lainaosuus
                    : this.taxDetails.lainaosuus).replace('.', ',')} €`,
                },
              ],
              [
                {
                  text: 'Velaton kauppahinta:',
                },
                {
                  text: `${(offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.kauppahinta
                    : this.taxDetails.kauppahinta).replace('.', ',')} €`,
                },
              ],
              [
                {
                  text: 'Kauppahinnan vero:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? this.currency(offerer.taxStatus.certificate.kauppahinnanvero)
                    : this.currency(this.taxDetails.kauppahinnanvero),
                },
              ],
              [
                {
                  text: 'Yhtiölainan vero:',
                },
                {
                  // eslint-disable-next-line no-nested-ternary
                  text: offerer.taxStatus.certificate
                    ? (offerer.taxStatus.certificate.yhtiolainanvero ? this.currency(offerer.taxStatus.certificate.yhtiolainanvero) : '0 €')
                    : (this.taxDetails.yhtiolainanvero ? this.currency(this.taxDetails.yhtiolainanvero) : '0 €'),
                },
              ],
              [
                {
                  text: 'Osin varainsiirtoverosta vapautetun ostajan maksama vero:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? this.currency(offerer.taxStatus.certificate.firstTimeBuyerTax)
                    : this.currency(this.taxDetails.firstTimeBuyerTax),
                },
              ],
              ...this.additionalSharesFromCertificatePdf(offerer),
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 0, 0, 5],
                },
                ' ',
              ],
              [
                {
                  text: 'Verot yhteensä:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? this.currency(offerer.taxStatus.certificate.yhteensavero)
                    : this.currency(this.taxDetails.yhteensavero),
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 0, 0, 5],
                },
                ' ',
              ],
              [
                {
                  text: offerer.ensiasunnonostaja ? 'Luovutuksensaaja täyttää oman ilmoituksensa mukaisesti varainsiirtoverovapautta koskevat edellytykset.' : ' ',
                  colSpan: 2,
                  margin: [0, 10, 0, 10],
                },
                ' ',
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 5, 0, 5],
                },
                ' ',
              ],
              [
                {
                  text: 'Nimi:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.BuyerName : offerer.nimi,
                },
              ],
              [
                {
                  text: 'Henkilötunnus / Y-tunnus:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.BuyerID : offerer.sotu,
                },
              ],
              [
                {
                  text: 'Omistusosuus:',
                },
                {
                  text: `${offerer.osuus} / ${offerer.jakaja}`,
                },
              ],
              [
                {
                  text: 'Maksettu varainsiirtovero:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? this.currency(offerer.taxStatus.certificate.AmountTransferTax)
                    : this.totalForOfferer(offerer),
                },
              ],
              [
                {
                  text: 'Vastaanottonumero:',
                },
                {
                  text: offerer.taxStatus.UniqueIdentifier,
                },
              ],
              [
                {
                  text: 'Vastaanottoaika:',
                },
                {
                  text: this.formatDateTime(offerer.taxStatus.AcceptedTimestamp),
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 10, 0, 10],
                },
                ' ',
              ],
              [
                {
                  text: 'Kiinteistönvälitystoimisto:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.RealEstateAgencyName
                    : this.currentProperty.companyName,
                },
              ],
              [
                {
                  text: 'Y-tunnus:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.RealEstateAgencyID
                    : this.currentProperty.companyVat,
                },
              ],
              [
                {
                  text: 'Osoite:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.RealEstateAgencyAddress
                    : this.currentProperty.companyAddress,
                },
              ],
              [
                {
                  text: 'Puhelin:',
                },
                {
                  text: offerer.taxStatus.certificate
                    ? offerer.taxStatus.certificate.RealEstateAgencyPhone
                    : this.currentProperty.companyPhone,
                },
              ],
            ],
          },
          margin: [0, -10, 0, 7],
          layout: 'noBorders',
        };
      } else if (this.taxDetails.osakevaikiinteisto > 0) {
        content = {
          table: {
            widths: ['*', '*'],
            body: [
              [
                {
                  text: 'VARAINSIIRTOVERON MAKSUTIEDOT\n',
                  fontSize: 15,
                  color: '#333333',
                  colSpan: 2,
                  margin: [0, 0, 0, 20],
                },
                ' ',
              ],
              [
                {
                  text: 'Taloyhtiö:',
                },
                {
                  text: this.currentProperty.yhtionimi,
                },
              ],
              [
                {
                  text: 'Y-tunnus:',
                },
                {
                  text: this.currentProperty.ytunnus,
                },
              ],
              [
                {
                  text: 'Paikkakunta:',
                },
                {
                  text: this.currentProperty.paikkakunta,
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 0, 0, 5],
                },
                ' ',
              ],
              [
                {
                  text: 'Velaton kokonaiskauppahinta:',
                },
                {
                  text: this.currentProperty.add_share > 0
                    ? this.currency(+this.taxDetails.kauppahinta
                      + +(this.taxDetails.additionalShares.shareSellingPrice || 0))
                    : this.currency(+this.taxDetails.kauppahinta),
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 0, 0, 5],
                },
                ' ',
              ],
              [
                {
                  text: 'Osakkeiden numerot:',
                  bold: true,
                },
                {
                  text: `${this.currentProperty.osakealku} - ${this.currentProperty.osakeloppu}`,
                },
              ],
              [
                {
                  text: 'Huoneistotunnus:',
                },
                {
                  text: this.currentProperty.huoneistonro,
                },
              ],
              [
                {
                  text: 'Pinta-ala:',
                },
                {
                  text: this.area(this.currentProperty.yhtpintaala),
                },
              ],
              [
                {
                  text: 'Kohteen tyyppi:',
                },
                {
                  text: this.assetTypes[this.taxDetails.assetDetails.asset || 1],
                },
              ],
              [
                {
                  text: 'Luovutuksen tyyppi:',
                },
                {
                  text: this.transferTypes[this.taxDetails.assetDetails.transferType || 1],
                },
              ],
              [
                {
                  text: 'Kaupantekopäivä:',
                },
                {
                  text: this.taxDetails.kaupantekopaiva,
                },
              ],
              [
                {
                  text: 'Kauppahinta:',
                },
                {
                  text: this.currency(this.taxDetails.kauppahintailmanlainaosuutta),
                },
              ],
              [
                {
                  text: 'Yhtiölainaosuus:',
                },
                {
                  text: this.currency(this.taxDetails.lainaosuus),
                },
              ],
              [
                {
                  text: 'Velaton kauppahinta:',
                },
                {
                  text: this.currency(this.taxDetails.kauppahinta),
                },
              ],
              [
                {
                  text: 'Kauppahinnan vero:',
                },
                {
                  text: this.currency(this.taxDetails.kauppahinnanvero),
                },
              ],
              [
                {
                  text: 'Yhtiölainan vero:',
                },
                {
                  text: this.currency(this.taxDetails.yhtiolainanvero),
                },
              ],
              [
                {
                  text: 'Osin varainsiirtoverosta vapautetun ostajan maksama vero:',
                },
                {
                  text: this.currency(this.taxDetails.firstTimeBuyerTax),
                },
              ],
              ...this.additionalSharesPdf(),
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 0, 0, 5],
                },
                ' ',
              ],
              [
                {
                  text: 'Verot yhteensä:',
                },
                {
                  text: this.currency(this.taxDetails.yhteensavero),
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 0, 0, 5],
                },
                ' ',
              ],
              [
                {
                  text: offerer.ensiasunnonostaja ? 'Luovutuksensaaja täyttää oman ilmoituksensa mukaisesti varainsiirtoverovapautta koskevat edellytykset.' : ' ',
                  colSpan: 2,
                  margin: [0, 2, 0, 2],
                },
                ' ',
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 5, 0, 5],
                },
                ' ',
              ],
              [
                {
                  text: 'Nimi:',
                },
                {
                  text: offerer.nimi,
                },
              ],
              [
                {
                  text: 'Henkilötunnus / Y-tunnus:',
                },
                {
                  text: offerer.sotu,
                },
              ],
              [
                {
                  text: 'Omistusosuus:',
                },
                {
                  text: `${offerer.osuus} / ${offerer.jakaja}`,
                },
              ],
              [
                {
                  text: 'Maksettava määrä:',
                },
                {
                  text: this.currency(this.totalForOfferer(offerer)),
                },
              ],
              [
                {
                  text: 'Viitenumero:',
                },
                {
                  text: offerer.reference ? offerer.reference : 'Ei yhteyttä verohallintoon',
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 3, 0, 3],
                },
                ' ',
              ],
              [
                {
                  text: 'Saaja:',
                },
                {
                  text: 'Verohallinto',
                },
              ],
              [
                {
                  text: 'NORDEA:',
                },
                {
                  text: this.banks.nordea,
                },
              ],
              [
                {
                  text: 'DANSKE BANK:',
                },
                {
                  text: this.banks.danske,
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 5, 0, 5],
                },
                ' ',
              ],
              [
                {
                  text: 'Kiinteistönvälitystoimisto:',
                },
                {
                  text: this.currentProperty.companyName,
                },
              ],
              [
                {
                  text: 'Y-tunnus:',
                },
                {
                  text: this.currentProperty.companyVat,
                },
              ],
              [
                {
                  text: 'Osoite:',
                },
                {
                  text: this.currentProperty.companyAddress,
                },
              ],
              [
                {
                  text: 'Puhelin:',
                },
                {
                  text: this.currentProperty.companyPhone,
                },
              ],
            ],
          },
          margin: [0, -10, 0, 7],
          layout: 'noBorders',
        };
      } else {
        content = {
          table: {
            widths: ['*', '*'],
            body: [
              [
                {
                  text: 'VARAINSIIRTOVERON MAKSUTIEDOT\n',
                  fontSize: 16,
                  color: '#333333',
                  colSpan: 2,
                  margin: [0, 0, 0, 30],
                },
                ' ',
              ],
              [
                {
                  text: 'Kiinteistötunnus:',
                },
                {
                  text: this.currentProperty.omkkiinteistotunnus,
                },
              ],
              [
                {
                  text: 'Katuosoite:',
                },
                {
                  text: this.currentProperty.kohdenimi,
                },
              ],
              [
                {
                  text: 'Paikkakunta:',
                },
                {
                  text: this.currentProperty.kaupunki,
                },
              ],
              [
                {
                  text: 'Pinta-ala:',
                },
                {
                  text: `${this.currentProperty.pintaala.replace('.', ',')} m²`,
                },
              ],
              [
                {
                  text: 'Kaupantekopäivä:',
                },
                {
                  text: this.taxDetails.kaupantekopaiva,
                },
              ],
              [
                {
                  text: 'Kauppahinta:',
                },
                {
                  text: this.currency(this.taxDetails.kauppahintailmanlainaosuutta),
                },
              ],
              [
                {
                  text: 'Osin varainsiirtoverosta vapautetun ostajan maksama vero:',
                },
                {
                  text: this.currency(this.taxDetails.firstTimeBuyerTax),
                },
              ],
              [
                {
                  text: 'Verot yhteensä:',
                },
                {
                  text: this.currency(this.taxDetails.yhteensavero),
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 10, 0, 10],
                },
                ' ',
              ],
              [
                {
                  text: offerer.ensiasunnonostaja ? 'Luovutuksensaaja täyttää oman ilmoituksensa mukaisesti varainsiirtoverovapautta koskevat edellytykset.' : ' ',
                  colSpan: 2,
                  margin: [0, 10, 0, 10],
                },
                ' ',
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 10, 0, 10],
                },
                ' ',
              ],
              [
                {
                  text: 'Nimi:',
                },
                {
                  text: offerer.nimi,
                },
              ],
              [
                {
                  text: 'Henkilötunnus / Y-tunnus:',
                },
                {
                  text: offerer.sotu,
                },
              ],
              [
                {
                  text: 'Omistusosuus:',
                },
                {
                  text: `${offerer.osuus} / ${offerer.jakaja}`,
                },
              ],
              [
                {
                  text: 'Maksettava määrä:',
                },
                {
                  text: this.currency(this.totalForOfferer(offerer)),
                },
              ],
              [
                {
                  text: 'Viitenumero:',
                },
                {
                  text: offerer.reference ? offerer.reference : 'Ei yhteyttä verohallintoon',
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 3, 0, 3],
                },
                ' ',
              ],
              [
                {
                  text: 'Saaja:',
                },
                {
                  text: 'Verohallinto',
                },
              ],
              [
                {
                  text: 'NORDEA:',
                },
                {
                  text: this.banks.nordea,
                },
              ],
              [
                {
                  text: 'DANSKE BANK:',
                },
                {
                  text: this.banks.danske,
                },
              ],
              [
                {
                  text: ' ',
                  colSpan: 2,
                  margin: [0, 10, 0, 10],
                },
                ' ',
              ],
              [
                {
                  text: 'Kiinteistönvälitystoimisto:',
                },
                {
                  text: this.currentProperty.companyName,
                },
              ],
              [
                {
                  text: 'Y-tunnus:',
                },
                {
                  text: this.currentProperty.companyVat,
                },
              ],
              [
                {
                  text: 'Osoite:',
                },
                {
                  text: this.currentProperty.companyAddress,
                },
              ],
              [
                {
                  text: 'Puhelin:',
                },
                {
                  text: this.currentProperty.companyPhone,
                },
              ],
            ],
          },
          margin: [0, -10, 0, 7],
          layout: 'noBorders',
        };
      }

      const docDefinition = {
        content,
        defaultStyle: {
          font: 'Roboto',
          fontSize: 9,
        },
        pageMargins: [50, 30, 50, 30],
        styles: {
          grayLines: {
            hLineColor: () => 'gray',
            vLineColor: () => 'gray',
          },
        },
      };
      pdfMake.createPdf(docDefinition).download(`varainsiirtovero_${offerer.nimi}.pdf`);
    },
    editSeller(seller) {
      this.editedPerson = _.cloneDeep(seller);
      this.sellerDialog = true;
    },
    async editOfferer(offerer) {
      this.editedPerson = _.cloneDeep(offerer);
      this.$bus.$emit('editCustomer');
      this.offererDialog = true;
    },
    businessOrIndividual(value) {
      if (value === '') return 'Tarkista y-tunnus / henkilötunnus!';
      if (value.length === 9) return 'Yritys';
      return 'Yksityishenkilö';
    },
    async sendTaxTransferDetails(offerer) {
      this.sending = true;
      try {
        const SellerDetails = [];

        this.currentProperty.sellers.forEach((seller) => {
          let InterestCorporateBuyerIndividualSeller = false;
          const icbis = this.businessOrIndividual(seller.sotu) !== 'Yritys'
            && this.businessOrIndividual(offerer.sotu) === 'Yritys'
            && Array.isArray(offerer.interestDetail)
            && offerer.interestDetail
              .find(s => s.henkilo_id === seller.id);

          if (icbis && icbis.InterestCorporateBuyerIndividualSeller) {
            ({ InterestCorporateBuyerIndividualSeller } = icbis);
          }

          let InterestIndividualBuyerCorporateSeller = false;
          const iibcs = this.businessOrIndividual(seller.sotu) === 'Yritys'
            && this.businessOrIndividual(offerer.sotu) !== 'Yritys'
            && Array.isArray(offerer.interestDetail)
            && offerer.interestDetail
              .find(s => s.henkilo_id === seller.id);

          if (iibcs && iibcs.InterestIndividualBuyerCorporateSeller) {
            ({ InterestIndividualBuyerCorporateSeller } = iibcs);
          }

          const sellerObject = {
            SellerIndividualOrCorporate:
              this.businessOrIndividual(seller.sotu) === 'Yritys' ? 2 : 1,
            SellerID: seller.sotu,
            SellerName: seller.nimi,
            SellerOwnershipShareFractions: `${seller.omistusosuus}/${seller.jakaja}`,
            InterestCorporateBuyerIndividualSeller,
            InterestIndividualBuyerCorporateSeller,
          };

          if (this.isBusiness(seller.sotu) && this.isBusiness(offerer.sotu)) {
            // TODO LISÄÄ KÄYTTÖLIITTYMÄ
            sellerObject.InterestCorporateBuyerSeller = false;
          }
          if (this.taxDetails.assetDetails.asset && this.taxDetails.assetDetails.asset > 2) {
            delete sellerObject.SellerOwnershipShareFractions;
            delete sellerObject.InterestCorporateBuyerIndividualSeller;
            delete sellerObject.InterestIndividualBuyerCorporateSeller;
          }

          SellerDetails.push(sellerObject);
        });

        const FirstTimeHomeBuyer = [{
          Conditions: this.firstTimeBuyerValue === 'Kyllä, ostaja vakuuttaa' ? 2 : 3,
          PortionOfSellingPrice: +this.taxDetails.assetDetails.portionOfSellingPrice || 0,
        }];

        const AssetDetails = {
          Asset: this.taxDetails.assetDetails.asset || 1,
          AcquiredPortionFractions: `${offerer.osuus}/${offerer.jakaja}`,
          CompanyID: this.currentProperty.ytunnus?.trim(),
          CompanyName: this.currentProperty.yhtionimi,
          ShareNumbers: `${this.currentProperty.osakealku}-${this.currentProperty.osakeloppu}`,
          QuantityOfShares: this.currentProperty.osakemaara,
          AreaM2: +this.currentProperty.yhtpintaala,
          ResidentialID: this.currentProperty.huoneistonro,
          // NewConstruction: this.currentProperty.uudiskohde > 0,
          OwnershipTransferDate: moment(this.taxDetails.omistusoikeuspaiva, 'DD.MM.YYYY')
            .format('YYYY-MM-DD'),
          BuyerShareOtherCompensation: 0.00,
          BuyerShareSellingPrice: +(this.taxDetails.kauppahintailmanlainaosuutta
            * (offerer.osuus / offerer.jakaja)).toFixed(2),
          BuyerShareLoan: +(this.taxDetails.lainaosuus
            * (offerer.osuus / offerer.jakaja)).toFixed(2),
          BuyerShareSellerHouseLoan: 0.00,
          BuyerShareTotalSellingPrice: +(this.taxDetails.kauppahinta
            * (offerer.osuus / offerer.jakaja)).toFixed(2),
          AmountTransferTax: +(+this.totalRegularForOfferer(offerer)).toFixed(2),
          // AmountTransferTax: +(+this.portionOfTax(this.taxTotals.regular, offerer)).toFixed(2),
          AddSellingPrice: false,
          SellerDetails,
        };

        let additionalAssetDetails = {};

        if (offerer.ensiasunnonostaja) {
          AssetDetails.FirstTimeHomebuyer = FirstTimeHomeBuyer;
        }

        if (this.taxDetails.assetDetails.asset && this.taxDetails.assetDetails.asset > 2) {
          delete AssetDetails.AreaM2;
          delete AssetDetails.BuyerShareOtherCompensation;
          delete AssetDetails.BuyerShareSellerHouseLoan;
        }
        if ((this.taxDetails.assetDetails.asset
          && parseInt(this.taxDetails.assetDetails.asset, 10) < 3)
          || this.taxDetails.assetDetails.asset === false
          || !this.taxDetails.assetDetails.asset
        ) {
          delete AssetDetails.QuantityOfShares;
        }

        const details = {
          certificateDetails: {
            kaupantekopaiva: this.taxDetails.kaupantekopaiva,
            omistusoikeuspaiva: this.taxDetails.omistusoikeuspaiva,
            asuntonaalkaenpvm: this.taxDetails.asuntonaalkaenpvm,
            kauppahinnanvero: this.taxDetails.kauppahinnanvero,
            kauppahinta: this.taxDetails.kauppahinta,
            kauppahintailmanlainaosuutta: this.taxDetails.kauppahintailmanlainaosuutta,
            lainaosuus: this.taxDetails.lainaosuus,
            yhtiolainanvero: this.taxDetails.yhtiolainanvero,
            yhteensavero: this.taxDetails.yhteensavero,
          },
          Sender: 1,
          BuyerID: offerer.sotu?.trim(),
          BuyerName: offerer.nimi,
          RealEstateAgencyID: this.currentProperty.companyVat?.trim(),
          RealEstateAgencyName: this.currentProperty.companyName,
          AgencyContactPersonName: this.currentProperty.activeAgentName || 'Asuntomyymälä',
          RealEstateAgencyPhone: this.currentProperty.companyPhone,
          RealEstateAgencyAddress: this.currentProperty.companyAddress,
          RealEstateAgencyPostCode: '26100',
          AssetDetails: [AssetDetails],
          SigningDate: moment(this.taxDetails.kaupantekopaiva, 'DD.MM.YYYY').format('YYYY-MM-DD'),
          TransferType: this.taxDetails.assetDetails.transferType || 1,
          AdvanceRuling: false,
          updateInfo: {
            offererId: offerer.henkilo_id,
            propertyId: this.propertyId,
            offerDetailId: offerer.tarjous_henkilo_id,
            share: `${offerer.osuus}/${offerer.jakaja}`,
          },
          email: offerer.email,
        };

        if (this.taxDetails.additionalShares.add_share > 0) {
          additionalAssetDetails = {
            Asset: parseInt(this.taxDetails.additionalShares.assetType, 10) || 1,
            AcquiredPortionFractions: `${offerer.osuus}/${offerer.jakaja}`,
            CompanyID: this.currentProperty.ytunnus?.trim(),
            CompanyName: this.currentProperty.yhtionimi,
            ShareNumbers: `${this.taxDetails.additionalShares.add_share}-${this.taxDetails.additionalShares.add_share2}`,
            QuantityOfShares: this.addShareCount,
            AreaM2: +this.taxDetails.additionalShares.area,
            ResidentialID: this.taxDetails.additionalShares.residentialID,
            // NewConstruction: this.currentProperty.uudiskohde > 0,
            OwnershipTransferDate: moment(this.taxDetails.omistusoikeuspaiva, 'DD.MM.YYYY')
              .format('YYYY-MM-DD'),
            BuyerShareOtherCompensation: 0.00,
            BuyerShareSellingPrice: +(
              (
                +this.taxDetails.additionalShares.shareSellingPrice
                - +this.taxDetails.additionalShares.buyerShareLoan)
              * (offerer.osuus / offerer.jakaja)).toFixed(2),
            BuyerShareLoan: +(this.taxDetails.additionalShares.buyerShareLoan
              * (offerer.osuus / offerer.jakaja)).toFixed(2),
            BuyerShareSellerHouseLoan: 0.00,
            BuyerShareTotalSellingPrice:
              +(+this.taxDetails.additionalShares.shareSellingPrice
                * (offerer.osuus / offerer.jakaja)).toFixed(2),
            AmountTransferTax: +(+this.totalAdditionalForOfferer(offerer)).toFixed(2),
            // AmountTransferTax: +this
            //   .portionOfTax(this.taxTotals.addshareTax, offerer, true).toFixed(2),
            AddSellingPrice: false,
            SellerDetails,
          };
          if ((this.taxDetails.additionalShares.asset
            && parseInt(this.taxDetails.additionalShares.asset, 10) < 3)
            || this.taxDetails.additionalShares.asset === false
            || !this.taxDetails.additionalShares.asset
          ) {
            delete additionalAssetDetails.QuantityOfShares;
          }
          details.AssetDetails.push(additionalAssetDetails);
          details.certificateDetails.addShareGroup = {
            area: +this.taxDetails.additionalShares.area,
            assetType: parseInt(this.taxDetails.additionalShares.assetType, 10) || 1,
            shareNumbers: `${this.taxDetails.additionalShares.add_share}-${this.taxDetails.additionalShares.add_share2}`,
            residentialID: this.taxDetails.additionalShares.residentialID,
            sellingPrice: this.addSharesSellingPrice,
            unencumberedSellingPrice: +this.additionalShares.shareSellingPrice,
            shareLoan: +this.taxDetails.additionalShares.buyerShareLoan,
            priceTax: this.taxDetails.addSummaryTax,
            loanTax: this.taxDetails.addSummaryLoanTax,
          };
        }
        details.certificateDetails.firstTimeBuyerTax = this.taxDetails.firstTimeBuyerTax;
        details.certificateDetails.totalTax = this.totalForOfferer(offerer);

        if (offerer.taxStatus && !!offerer.taxStatus.UniqueIdentifier) {
          details.ReplacementReturn = true;
          details.PreviousReturnKey = offerer.taxStatus.UniqueIdentifier;
        }

        const response = await this.sendTaxTransfer(details);
        await this.setCurrentProperty(this.propertyId);

        this.sending = false;
        if (response.result.UniqueIdentifier) {
          this.successDialog = true;
        }
      } catch (e) {
        console.warn(e);
        this.sending = false;
      }
      this.dialog = false;
    },
    portionOfTax(tax, offerer, additional = false) {
      if (additional) {
        if (offerer && offerer.ensiasunnonostaja
          && this.taxDetails.additionalShares.firstTimeBuyer) {
          return 0;
        }
        return ((tax) * (offerer.osuus / offerer.jakaja));
      }

      if (offerer && offerer.ensiasunnonostaja) {
        return 0;
      }
      return ((tax / this.taxDetails.verovelvollistenosuus) * (offerer.osuus / offerer.jakaja));
    },
    sendDialog(offerer) {
      this.dialog = true;
      this.selectedOfferer = offerer;
    },
  },
};
</script>

<style scoped lang="scss">
.v-alert {
  border-radius: 8px;
}
</style>
